







































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EmailVerificationResend } from '@/api';
import ResendCooldown from '@/mixins/ResendCooldown';

/**
 * Shown after a successful registration, in place of the form.
 *
 * Verification is non-blocking - the user can log in and bid without it - so
 * this is a prompt, not a wall.
 */
@Component
export default class CheckYourEmail extends Mixins(ResendCooldown) {
  @Prop({ default: '' }) email: string;

  loading: boolean = false;

  message: string = '';

  messageType: string = 'info';

  mounted() {
    // Registration has just sent the first email, so the countdown starts
    // straight away rather than only after a manual resend.
    this.startCooldown();
  }

  async resend() {
    if (this.cooldownActive) {
      return;
    }
    this.loading = true;
    this.message = '';
    try {
      await EmailVerificationResend.request(this.email);
      // The endpoint reports generic success whether or not the address exists
      // or is already verified, so this message must not claim more than that.
      this.messageType = 'info';
      this.message =
        'If that address needs confirming, another email is on its way.';
    } catch (e) {
      const status = e.response ? e.response.status : null;
      if (status === 429) {
        this.messageType = 'warning';
        this.message = 'Please wait a moment before requesting another email.';
      } else {
        this.messageType = 'error';
        this.message = 'That did not work just now. Please try again shortly.';
      }
    } finally {
      this.loading = false;
      // Every outcome starts the countdown, including the failures - a request
      // that errored is exactly the one a user retries in a hurry.
      this.startCooldown();
    }
  }
}
